import { generatePath, useParams } from "../../../../../router-utils"
import { WhatsAppInboxThread } from "../../../../../WhatsAppMessages"

export default function TripWhatsAppThreadPage() {
	const { tripId, threadId } = useParams("/trips/:tripId/whatsapp/:threadId")
	return (
		<WhatsAppInboxThread
			key={threadId}
			threadId={Number(threadId)}
			// Back belongs to the trip's own thread list, not the global inbox.
			backTo={generatePath("/trips/:tripId/whatsapp", { tripId })}
			trackingSurface="trip"
		/>
	)
}
